// src/pages/beta-community/components/CTASection.jsx
import React from 'react';
import { SUPPORT_EMAIL } from '../../../config/domains';

const CTASection = ({ navigate }) => {
  const handleEmailClick = () => {
    const subject = encodeURIComponent('Beta Community ARTKIV - candidature');
    const body = encodeURIComponent(
      `Bonjour Vanessa,\n\nJe suis intéressé(e) par la Beta Community ARTKIV.\n\nNom :\nPrénom :\nProfil : [Collectionneur / Art Advisor / Expert / Family Office / CGP]\nTéléphone :\n\nMerci de me recontacter pour identifier le parcours bêta le plus adapté.\n\nCordialement`
    );
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
  };

  return (
    <section id="inscription" className="cta-final">
      <div className="container">
        <h2 className="cta-final-title">Prêt à rejoindre la Beta Community ?</h2>
        <p className="cta-final-text">
          Places limitées par parcours. Les premiers membres aident à tester les usages réels de la plateforme : inventaire, partage, expertise, reporting et transmission.
        </p>
        
        <div className="cta-group">
          <button className="btn btn-primary" onClick={handleEmailClick}>
            Candidater par email
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => navigate('/beta-community/inscription')}
          >
            Formulaire en ligne
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;